export default __webpack_public_path__ + "static/media/roboto-v20-latin-300italic.283f1b27.svg";